import { Box, useTheme } from "@mui/material";

const DarkLightModeGradient = () => {
const theme = useTheme()

  return (
    <Box
      sx={{
        width: { xs: "320px", md: "484px" },
        height: { xs: "320px", md: "484px" },
        background: theme.palette.gradients.radialDark,
        borderRadius: "50%",
        opacity: 0.12,
        position: "absolute",
        zIndex: -1,
      }}
    />
  );
};

export default DarkLightModeGradient;
